import * as React from 'react';

import { FormControlLabel, RadioGroup, Typography } from '@mui/material';
import { Field } from 'react-final-form';

import { RoommateNumberID } from '@kamernet/core/ApiClient/Kamernet';
import { useIntl } from '@kamernet/core/Intl';
import { parseStringToInteger } from '@kamernet/utilities/Forms/FormsNormalizers';

import { Radio } from '@kamernet/components/FormFields/final-form/Radio/RadioInput';

import { RoommateNumberTranslations } from '../../translations';

import { SideFiltersFormFieldStyles } from './SideFiltersFormFieldStyles';

export interface RoommateNumberMaxFormFieldProps {
  allowedRoommateNumberMaxes: readonly RoommateNumberID[];
}

export const RoommateNumberMaxFormField = ({
  allowedRoommateNumberMaxes,
}: RoommateNumberMaxFormFieldProps) => {
  const { T } = useIntl();
  return (
    <React.Fragment>
      <Typography variant="h4">{T('LBL_ROOMMATES')}</Typography>
      <Typography variant="subtitle2">
        {T('LBL_NUMBER_OF_ROOMMATES')}
      </Typography>
      <RadioGroup className={SideFiltersFormFieldStyles.controlsGroupColumn}>
        {allowedRoommateNumberMaxes.map(roommateNumber => (
          <FormControlLabel
            key={roommateNumber}
            control={
              <Field
                name="roommateNumberMax"
                component={Radio}
                type="radio"
                value={roommateNumber}
                parse={parseStringToInteger}
              />
            }
            label={T(RoommateNumberTranslations[roommateNumber])}
          />
        ))}
      </RadioGroup>
    </React.Fragment>
  );
};
